import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FirebaseStorageService {
  constructor(private storage: AngularFireStorage) {}

  uploadFile(file: File, path: string): Observable<string> {
    const storageRef = this.storage.ref(path);
    return from(storageRef.put(file)).pipe(
      switchMap(() => storageRef.getDownloadURL())
    );
  }

  getCompanyLogoPath(companyId: string, fileName: string): string {
    return `company-logos/${companyId}/${fileName}`;
  }
}
